'use es6';

import { Record } from 'immutable';
import ContentRoutes from 'ContentUtils/Routes';
const DEFAULTS = {
  id: 0,
  label: '',
  url: ''
};

const getUrl = ({
  id
}) => ContentRoutes.forms(id);

export default class Form extends Record(DEFAULTS) {
  static fromJS(data) {
    const {
      id,
      label
    } = data;
    return new Form({
      id,
      label,
      url: getUrl(data)
    });
  }

}